let setAllTripAddresses = (state, tripAddressesDto) => {
	state.allTripAddresses = tripAddressesDto;
};

function set(state, fn) {
	if (fn)
		fn(state);
}

let setValue = (state, { value, key }) => {
	state[key] = value;
};

function setErrors(state, { errors, id }) {
	if (!errors) return;

	state.errors.invalidName = errors.invalidName || false;
	state.errors.invalidPostalCode = errors.invalidPostalCode || false;

	state.errors.name = errors.invalidName || false;
	state.errors.street = errors.invalidStreet || false;
	state.errors.postalPlace = errors.invalidPostalPlace || false;
	state.errors.postalCode = errors.invalidPostalCode || false;
	state.errors.countryCode = errors.invalidCountryCode || false;
	state.errors.id = id ? id : '';
}

function clearErrors(state) {
	state.errors.invalidName = false;
	state.errors.invalidPostalCode = false;

	state.errors.name = false;
	state.errors.street = false;
	state.errors.postalPlace = false;
	state.errors.postalCode = false;
	state.errors.countryCode = false;
	state.errors.id = '';
}

function setGlobalLocations(state, globalLocations) {
	state.globalLocations = {};
	for (let c of globalLocations) {
		state.globalLocations[c.id] = c;
	}
}

export default {
	setAllTripAddresses,
	set,
	setValue,
	setErrors,
	clearErrors,
	setGlobalLocations
};
